<template lang="pug">
ul.flixel__list(:class='{blocks: gridView}')
  // (flixels.results | filter: flixels.filter | limitTo: flixels.displayed)
  div(v-for='(flixel, index) in filteredFlixels',
      :class="( gridView ) ? 'flixel__list--portrait' : 'flixel__list--landscape' ")
    li.flixel__list--cinemagraph(:class='{"watermark--border": flixel.selected}' )

      flixelListGallery(
        v-if='!profilePage',
        class="iframe h-cover",
        :flixel='flixel',
        :index='index',
        )

      flixelListProfile(
        v-if='profilePage',
        class="iframe h-cover",
        :flixel='flixel',
        :index='index',)
      
      .h-cover(v-if='returnStatus(flixel.status) !== "complete"')
        .background.list--shadow.h-textcenter
          p(v-if='returnStatus(flixel.status) !== "complete" && returnStatus(flixel.status) !== "failed"') We are processing your cinemagraph.
          p(v-if='returnStatus(flixel.status) === "failed"') We could not process your cinemagraph. <br> Please try uploading again.
        router-link.link_ovelay(to="{name: 'Flixel', params: { hash: flixel.hash } }")

    .flixel__list--accreditation(v-if='!profilepage')
      router-link(:to="{ name: 'Profile', params: { username: flixel.username } }")
        .accreditation__item
          img(:src="flixel.user_avatar", v-if='flixel.user_avatar')
          p {{ flixel.username }}

    p(v-if='!isLoading && flixelsObj.count === 0') No cinemagraphs found.

  .row(v-if='isLoading')
    .columns.small-12
      .loading__lazy
        .spinner
</template>

<script>
import FlixelService from 'services/flixel.es6.js';
import FlixelListGallery from './FlixelListGallery.vue';
import FlixelListProfile from './FlixelListProfile.vue';

export default {
  name: 'Flixel-List',
  props: ['flixels', 'gridView', 'profilePage'],
  data() {
    return {
      flixel: '',
      flixelsObj: {
        displayed: 24,
        data: {
          results: [],
        },
      },
      apiMapping: '',
      user: '',
      profilepage: '',
      isLoading: false,
    };
  },
  mounted() {
    const self = this;
    if (this.gridView === undefined) {
      this.gridView = true;
    }
    window.addEventListener('scroll', function () {
      if ((window.innerHeight + Math.ceil(window.pageYOffset + 1)) >= document.body.offsetHeight) {
        if (!self.isLoading) {
          self.displayMoreFlixels();
        }
      }
    });
  },
  computed: {
    filteredFlixels: function () {
      return this.flixelsObj.data.results.slice(0, this.flixelsObj.displayed);
    },
  },
  watch: {
    flixels(newVal, oldVal) {
      const self = this;
      self.isLoading = true;
      self.flixelsObj = newVal;
      self.isLoading = false;
    },
  },
  methods: {
    loadMoreFromApiInvoke(url) {
      this.isLoading = true;
      const options = this.prep(url);
      FlixelService.getList(options)
        .then(this.loadMoreFromApiSuccess, this.loadMoreFromApiError);
    },

    loadMoreFromApiSuccess(response) {
      this.flixelsObj.data.next = response.data.next;
      this.flixelsObj.data.results = this.flixels.data.results.concat(response.data.results);
      this.disableLazyLoading = false;
      this.isLoading = false;
    },

    loadMoreFromApiError(error) {
      console.log(error);
      return error;
    },

    prep(url) {
      const options = {
        url: url.replace('http://', 'https://'),
        params: {
          page_size: 50,
        },
      };

      return options;
    },

    displayMoreFlixels() {
      let urlToLoadMore = '';
      const moreToDisplay = this.flixelsObj.data
                            && this.flixelsObj.displayed
                            <= this.flixelsObj.data.results.length;
      if (moreToDisplay) {
        this.flixelsObj.displayed += 8;
      }
      if (!moreToDisplay && this.flixelsObj && this.flixelsObj.data.results) {
        this.disableLazyLoading = true;
        urlToLoadMore = this.flixelsObj.data.next;
        if (urlToLoadMore) {
          this.loadMoreFromApiInvoke(urlToLoadMore);
        } else {
          this.flixelsObj.isLoading = false;
        }
      }
    },

    goToFlixel(hash, collection, index) {
      if (collection) {
        collection.index = index;
      }

      FlixelService.savedList = collection;
      this.$router.push('flixel', { hash: hash });
    },

    positionWatermark(flixel) {
      const x = flixel.watermark_position_x;
      const y = flixel.watermark_position_y;
      const obj = {
        width: flixel.watermark_scale + '%',
      };
      obj[x] = '5px';
      obj[y] = '5px';
      return obj;
    },
    returnStatus(flixel) {
      return FlixelService.returnStatus(flixel);
    },
  },
  components: {
    'flixelListGallery': FlixelListGallery,
    'flixelListProfile': FlixelListProfile,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/FlixelList.vue